import { Address } from '../types/common';

export const formatAddress = (address: Address): string => {
  return `${address.street}, ${address.postalCode} ${address.city}, ${address.country}`;
};

/**
 * Árajánlat-szám: YC-<év>-<6 véletlen karakter>, pl. YC-2026-K7F3QX.
 * Szándékosan nem sorszám, hogy az ügyfél ne következtethessen belőle az ajánlatok számára.
 * Kétértelmű karakterek (0/O, 1/I/L) nélkül; ütközés esetén újat sorsol.
 */
export const generateQuotationNumber = (
  _lastQuotationNumber?: string,
  _customerShortName?: string,
  allQuotations: any[] = [],
  _customerId?: string
): string => {
  const alphabet = 'ABCDEFGHJKMNPQRSTUVWXYZ23456789';
  const year = new Date().getFullYear();
  const used = new Set((allQuotations || []).map((q: any) => q?.quotationNumber || q?.number).filter(Boolean));
  const pick = () => {
    const bytes = new Uint8Array(6);
    (globalThis.crypto || (window as any).crypto).getRandomValues(bytes);
    return Array.from(bytes, b => alphabet[b % alphabet.length]).join('');
  };
  let num = `YC-${year}-${pick()}`;
  for (let k = 0; k < 10 && used.has(num); k++) num = `YC-${year}-${pick()}`;
  return num;
};

// Currency formatter function
export const formatCurrency = (amount: number, currency: string = 'HUF'): string => {
  if (isNaN(amount)) return '0 ' + currency;
  
  return new Intl.NumberFormat('hu-HU', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
};

// Segédfüggvény a dokumentum dátumának formázásához
export const formatDocumentDate = (date: any): string => {
  try {
    if (!date) return '-';

    // Ha Timestamp objektum
    if (date && typeof date.toDate === 'function') {
      const d = date.toDate();
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
    }

    // Ha Date objektum
    if (date instanceof Date) {
      return `${date.getFullYear()}.${String(date.getMonth() + 1).padStart(2, '0')}.${String(date.getDate()).padStart(2, '0')}.`;
    }

    // Ha szám (pl. timestamp)
    if (typeof date === 'number') {
      const d = new Date(date);
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
    }

    // Ha objektum seconds mezővel (Firebase Timestamp-szerű objektum)
    if (typeof date === 'object' && date !== null && 'seconds' in date) {
      const d = new Date(date.seconds * 1000);
      return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
    }

    // Utolsó próbálkozás - konvertálás számra
    const d = new Date(Number(date));
    return `${d.getFullYear()}.${String(d.getMonth() + 1).padStart(2, '0')}.${String(d.getDate()).padStart(2, '0')}.`;
  } catch (error) {
    return '-';
  }
};